import {
  ActualNameCreator,
  createActualBlockName,
  normalizeCommonFields
} from '../common';

import {
  IActionHttpRequestParams,
  ActionHttpRequestNormalizer
} from './client';
import { ActionHttpRequestMethod, mapHttpRequestMethodToTitle } from './server';

const createActionHttpRequestActualNameBase = ({
  method,
  url
}: {
  method: ActionHttpRequestMethod;
  url: string;
}): string => {
  return `${mapHttpRequestMethodToTitle[method]} ${url}`;
};

export const createActionHttpRequestActualName: ActualNameCreator<
  IActionHttpRequestParams
> = ({ params }) =>
  createActionHttpRequestActualNameBase({
    method: params.method,
    url: params.url.value
  });

export const normalizeActionHttpRequest: ActionHttpRequestNormalizer = (
  raw,
  stores
) => {
  return {
    ...normalizeCommonFields(raw, stores),
    actualName: (t) =>
      createActualBlockName({
        paramsName: createActionHttpRequestActualNameBase({
          method: raw.params.method,
          url: raw.params.url
        }),
        blockKind: raw.kind,
        blockName: raw.name,
        t,
        ...stores
      })
  };
};
